import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DownloadIcon from '@mui/icons-material/Download';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import MilitaryTechRoundedIcon from '@mui/icons-material/MilitaryTechRounded';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import CallEndRoundedIcon from '@mui/icons-material/CallEndRounded';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import About from '../../pages/About/About';
import Project from '../../pages/Project/Project';
import Education from '../../pages/Education/Education';
import TechStack from '../../pages/TechStack/TechStack';
import Experience from '../../pages/Experience/Experience';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

import './Manu2.css';
import profile from '../images/profile.jpg';
import Contact from '../../pages/Contanct/Contact';
import { Link, animateScroll as scroll } from 'react-scroll';
import Typewriter from 'typewriter-effect';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CodeIcon from '@mui/icons-material/Code';

import myResume from '../../Assets/My resume 2024 v-5.pdf'

const drawerWidth = 230;

function ResponsiveDrawer(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <div style={{ height: "100vh", backgroundColor: "white" }}>
      <Toolbar />
      <div className='profile'>
        <img src={profile} alt='profile-photo' className='img-pro' />
        <div>
          <p className='name-text'>Arjun Chauhan</p>
        </div>
      </div>

      <List>
        {[
          { id: "1", text: 'Home', icon: <AddHomeRoundedIcon sx={{ color: "#9100C3" }} />, to: 'home' },
          { id: "2", text: 'About', icon: <InfoTwoToneIcon sx={{ color: "#9100C3" }} />, to: 'about' },
          { id: "3", text: 'Education', icon: <SchoolOutlinedIcon sx={{ color: "#9100C3" }} />, to: 'education' },
          { id: "4", text: 'Projects', icon: <AccountTreeRoundedIcon sx={{ color: "#9100C3" }} />, to: 'projects' },
          { id: "5", text: 'Tech-Stack', icon: <MilitaryTechRoundedIcon sx={{ color: "#9100C3" }} />, to: 'techstack' },
          { id: "6", text: 'Experience', icon: <BusinessCenterRoundedIcon sx={{ color: "#9100C3" }} />, to: 'experience' },
          { id: "7", text: 'Contact', icon: <CallEndRoundedIcon sx={{ color: "#9100C3" }} />, to: 'contact' },
        ].map((item) => (
          <ListItem key={item.id} disablePadding sx={{ '&:hover': { backgroundColor: '#F9ECFF' } }}>
            <Link to={item.to} smooth={true} duration={100} hashSpy={true} offset={-64} spy={true}>
              <ListItemButton onClick={handleDrawerClose}>
                <ListItemIcon sx={{ '&:hover': { color: "white" } }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} sx={{
                  color: "#3B485D",
                  '& .MuiTypography-root': {
                    '&:hover': {
                      color: '#9100C3',
                    }
                  }
                }} />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>

      <Divider />

      <Box sx={{ '& > :not(style)': { m: 1 } }}>
      <Fab size="small" color="secondary" aria-label="add">
        <CodeIcon/>
      </Fab>
      <Fab size="medium" color="secondary" aria-label="add">
      <a href='https://github.com/Arjun-kn' style={{ textDecoration: 'none', color: 'black' }}><GitHubIcon /></a>
        
      </Fab>
      <Fab color="secondary" aria-label="add">
       <a href="https://www.linkedin.com/in/arjunrchauhan/"> <LinkedInIcon /></a>
      </Fab>
    </Box>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: "#7C53D8",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
            <Typography variant="h6" noWrap component="div">
              Hello I'am
              <Typewriter
                options={{
                  strings: ['Frontend Web Developer', 'MERN Stack Developer', 'Full Stack Web Developer'],
                  autoStart: true,
                  loop: true,
                }}
              />
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', gap: 2  }}>
              <Button variant="outlined" size="small" sx={{ color: "white", padding:"3px",'&:hover':{color:"white",backgroundColor:"black"}}} className='btn' >
                <IconButton sx={{ color: "red", backgroundColor: "white" ,'&:hover':{color:"#9100C3"}}} size='small' >
                  <DownloadIcon sx={{fontSize:"15px"}} />
                </IconButton>
                
                <a href={myResume} download="Arjun_Chauhan_Resume.pdf" style={{ textDecoration: 'none', color: 'inherit',fontSize:"8px" }}>
                My Resume
              </a>
              </Button>
              <Button variant="outlined" size="small" sx={{ color: "white",'&:hover':{color:"white",backgroundColor:"black"} }} className='btn' >
                <IconButton sx={{ color: "green", backgroundColor: "white",fontSize:"10px" ,'&:hover':{color:"#9100C3"}}} size='small'>
                  <WhatsAppIcon sx={{fontSize:"15px"}}/>
                </IconButton>
                <a href="https://wa.me/9321023910" style={{ textDecoration: 'none', color: 'inherit' ,fontSize:"8px"}} target="_blank" rel="noopener noreferrer">
            Connect Me
          </a>
              </Button>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <div id="home">
          {/* Your home component or content here */}
        </div>
        <div id="about">
          <About />
        </div>
        <div id="education">
          <Education />
        </div>
        <div id="projects">
          <Project />
        </div>
        <div id="techstack">
          <TechStack />
        </div>
        <div id="experience">
          <Experience />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </Box>
    </Box>
  );
}

ResponsiveDrawer.propTypes = {
  window: PropTypes.func,
};

export default ResponsiveDrawer;
